import React, { FC } from "react";
import styled, { css } from "styled-components";

const KionTag: FC = () => {
  return (
    <Wrapper>
      <Bg src="../../static/icons/kion-bg.svg" />
      <Badge>KION в подарок</Badge>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
`;

const Bg = styled.img`
  display: block;
`;

const Badge = styled.span`
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default KionTag;
